export default __webpack_public_path__ + "static/media/room1-MASK-Zahner2.66d71fcf.png";